module.exports = __webpack_public_path__ + "media/images/icon-twitter-e720905ba63bd8c5d8efb7ed6a958d9a.svg";